<script>
export default {
    props: {
        inputPrepend: {
            type: [String, Number, Object],
            default() {
                return {
                    component: 'oc-icon',
                    attrs: {
                        type: 'calendar'
                    }
                }
            }
        }
    }
}
</script>
